export default "__VITE_ASSET__bbc2ec62__"